export default __webpack_public_path__ + "static/media/img_blanketBunny_beige.00abe8dc.jpg";